import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=6ffff7c4&scoped=true&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"
import style0 from "./PageSection.vue?vue&type=style&index=0&id=6ffff7c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffff7c4",
  null
  
)

export default component.exports